// Advisory branch labels — decode pairing (construct.R12).

/** The one decided wording for the undiagnosed / zero-touch state (DESIGN.md § Decided). */
export const ZERO_TOUCH_UNDIAGNOSED = 'zero-touch · no diagnosis';

export const ZERO_TOUCH = {
  label: ZERO_TOUCH_UNDIAGNOSED,
  decode: 'No diagnosis — a person still acts',
  kpiTile: ZERO_TOUCH_UNDIAGNOSED,
  shareTitle: 'Zero-touch share',
  branchClosedCaption: 'zero-touch branch closed this shift',
  branchInSentence: 'zero-touch branch',
  croKpiTile: ZERO_TOUCH_UNDIAGNOSED,
  nonBranchCaption: 'metallurgy queue · diagnosed branch',
} as const;

export const BRANCH_LABELS = {
  'zero-touch': ZERO_TOUCH,
} as const;
